export enum EmailActionType {
  SendEmail = '@quidproquo-webserver/Email/SendEmail',
  SetDeliveryStatus = '@quidproquo-webserver/Email/SetDeliveryStatus',
}
